export default __webpack_public_path__ + "static/media/no_image.32404647.png";